// Metered paywall: a few free premium articles per calendar month, tracked in localStorage.
const FREE_LIMIT = 3;
const KEY = "nl_meter";

function monthStamp() {
  const d = new Date();
  return `${d.getFullYear()}-${d.getMonth()}`;
}

function read() {
  try {
    const raw = JSON.parse(localStorage.getItem(KEY) || "{}");
    if (raw.month !== monthStamp()) return { month: monthStamp(), slugs: [] };
    return raw;
  } catch {
    return { month: monthStamp(), slugs: [] };
  }
}

export function isSubscriber() {
  return localStorage.getItem("nl_subscriber") === "true";
}

export function setSubscriber(v) {
  localStorage.setItem("nl_subscriber", v ? "true" : "false");
  window.dispatchEvent(new Event("nl-meter-change"));
}

export const FREE_ARTICLE_LIMIT = FREE_LIMIT;

export function freeReadsUsed() {
  return read().slugs.length;
}

export function freeReadsLeft() {
  if (isSubscriber()) return FREE_LIMIT;
  return Math.max(0, FREE_LIMIT - read().slugs.length);
}

// Returns true if the reader may view the full premium article.
export function registerPremiumView(slug) {
  if (isSubscriber()) return true;
  const data = read();
  if (data.slugs.includes(slug)) return true;
  if (data.slugs.length >= FREE_LIMIT) return false;
  data.slugs.push(slug);
  localStorage.setItem(KEY, JSON.stringify(data));
  window.dispatchEvent(new Event("nl-meter-change"));
  return true;
}

export function canViewPremium(slug) {
  if (isSubscriber()) return true;
  const data = read();
  if (data.slugs.includes(slug)) return true;
  return data.slugs.length < FREE_LIMIT;
}
